import { Row } from "react-bootstrap";
import { ISwapTracker } from "@nkr/models/index";
import { SwapTrackerColWrapper, SwapTrackerStatusWrapper } from "./styles";

interface IProps {
    item: ISwapTracker;
}

const SwapTrackerListCard = (props: IProps) => {
    const renderExtraText = (extra: string) => {
        if (extra != null && extra != "") {
            return <>{extra}</>;
        } else {
            return <>&nbsp;</>
        }
    };

    const renderStep = (status: number, extra: string) => {
        if (status == 0) {
            return <SwapTrackerStatusWrapper backgroundColor="#ddd" color="black">{renderExtraText(extra)}</SwapTrackerStatusWrapper>;
        }

        if (status == 1) {
            return <SwapTrackerStatusWrapper backgroundColor="#34823b" color="white">{renderExtraText(extra)}</SwapTrackerStatusWrapper>;
        }

        if (status == 2) {
            return <SwapTrackerStatusWrapper backgroundColor="#ecef23" color="black">{renderExtraText(extra)}</SwapTrackerStatusWrapper>;
        }

        if (status == 3) {
            return <SwapTrackerStatusWrapper backgroundColor="#bc0505" color="white">{renderExtraText(extra)}</SwapTrackerStatusWrapper>;
        }
    };

    const item = props.item;

    return (
        <Row style={{ marginBottom: 20, border: "1px solid #aaa", paddingBottom: 10 }}>
            <SwapTrackerColWrapper className="bg-success" xs={12} style={{ paddingTop: 5, paddingBottom: 5, marginBottom: 5 }}>
                Swap <span style={{ marginLeft: 10, fontWeight: 700 }}>{item.chainId} / {item.clusterNumber} / {item.positionNumber}</span>
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Swap Manager:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.swapManager ? item.swapManager.name : ''}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Donor Center:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.donorCenter}
                {item.rdnCenterId > 0 ?
                    <span style={{ paddingLeft: 5 }}>(<span style={{ fontSize: 12, color: 'tomato', fontWeight: 600 }}>{item.rdnCenterAlias}</span>)</span>
                    : null}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Donor Alias:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.donorAlias}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Recipient Center:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.recipientCenter}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Recipient Alias:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.recipientAlias}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Surgery Date:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {item.surgeryDate}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Offer Acceptance:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {renderStep(item.offerAcceptance, '')}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Donor Record Review:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {renderStep(item.donorClearance, '')}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Serologies Returned:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {renderStep(item.serologiesReturned, item.shipBackDate)}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={6}>
                Serologies Recorded:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={6}>
                {renderStep(item.serologiesRecorded, '')}
            </SwapTrackerColWrapper>

            <SwapTrackerColWrapper xs={5}>
                Final XM Complete:
            </SwapTrackerColWrapper>
            <SwapTrackerColWrapper xs={7}>
                {renderStep(item.finalXmComplete, '')}
            </SwapTrackerColWrapper>
        </Row>
    );
}

export default SwapTrackerListCard;